const key = 'jsonpSaveList';

function getSaveList() {
  let result = [];
  let saveList = localStorage.getItem(key) || '[]';
  try {
    saveList = JSON.parse(saveList);
    result = Array.isArray(saveList) ? saveList : [];
  } catch (err) {

  }
  return result;
}

function setSaveList(saveList) {
  const newList = saveList.filter(item => {
    const now = Date.now();
    const sTime = now - item.createTime;
    const maxSTime = 12 * 60 * 60 * 1000;
    return sTime < maxSTime;
  });
  try {
    localStorage.setItem(key, JSON.stringify(newList));
  } catch (err) {
    localStorage.setItem(key, '[]');
  }
}

function equals(a, b) {
  let saveA = a;
  let saveB = b;
  let result = saveA === saveB;
  if (!result) {
    if (saveA && saveB && typeof saveA === 'object' && typeof saveB === 'object') {
      saveA = JSON.parse(JSON.stringify(a));
      saveB = JSON.parse(JSON.stringify(b));
      saveA.Token = null;
      saveB.Token = null;
      saveA.token = null;
      saveB.token = null;
      try {
        result = JSON.stringify(saveA) === JSON.stringify(saveB);
      } catch (err) {
        result = false;
      }
    }
  }
  return result;
}

function searchItem(list, url, params, options) {
  const matchItem = list.find(item => {
    const now = Date.now();
    const sTime = now - item.createTime;
    const maxSTime = 12 * 60 * 60 * 1000;
    return [
      equals(item.url, url),
      equals(item.params, params),
      equals(item.options, options),
      sTime < maxSTime
    ].filter(Boolean).length === 4;
  });
  return matchItem;
}

function searchResult(url, params, options) {
  const saveList = getSaveList();
  const matchItem = searchItem(saveList, url, params, options);
  return matchItem ? matchItem.data : null;
}

function saveItem(url, params, options, data) {
  const saveList = getSaveList();
  saveList.push({ url, params, options, createTime: Date.now(), data });
  setSaveList(saveList);
}

function sleep(times) {
  return new Promise(resolve => {
    setTimeout(resolve, times);
  });
}

function updateItem(ajax, url, params, options) {
  let saveList = getSaveList();
  let matchItem = searchItem(saveList, url, params, options);
  if (matchItem) {
    (async () => {
      await sleep(5000);
      const data = await sendJsonp(ajax, url, params, options);
      saveList = getSaveList();
      matchItem = searchItem(saveList, url, params, options);
      if (matchItem) {
        matchItem.createTime = Date.now();
        matchItem.data = data;
      } else {
        saveList.push({ url, params, options, createTime: Date.now(), data });
      }
      setSaveList(saveList);
    })();
  }
}

function sendJsonp(ajax, url, _params, _options) {
  const params = typeof _params === 'object' ? Object.assign({}, _params) : _params;
  const options = typeof _options === 'object' ? Object.assign({}, _options) : _options;
  return ajax.jsonp(url, params, options);
}

export default function (ajax) {
  return async (url, params, options) => {
    let result = null;
    result = searchResult(url, params, options);
    if (result) {
      updateItem(ajax, url, params, options);
    } else {
      result = await sendJsonp(ajax, url, params, options);
      saveItem(url, params, options, result);
    }
    return result;
  };
}



// WEBPACK FOOTER //
// ./src/utils/cacheJsonp.js